import {
    enrichDatapointWithAppVisibility,
    logPerformanceDatapoint as logPerformanceDatapointCore,
    resolveDatapointTimeGate,
} from 'owa-analytics-core';
import type { LogPerformanceDatapointParams } from 'owa-analytics-types';
import { getAnalyticsAddon } from 'owa-analytics-addons';
import { getThreadName } from 'owa-thread-config';
import { queueOrRun } from 'owa-analytics-utils';
import { alertWorkerLoggingError } from 'owa-analytics-utils/lib/alertWorkerLoggingError';
import { logToTracingPanel } from '../../utils/logToTracingPanel';
import { getAnalyticsFlightsAndAppSettings } from 'owa-analytics-core/lib/settings/getAnalyticsFlightsAndAppSettings';
import { isRunningOnWorker } from 'owa-config';
import { runDatapointTimeGateDiagnostics } from 'owa-analytics-core/lib/utils/datapointTimeGate';
import { cacheDatapointForDiagnostics } from '../../utils/cacheDatapointForDiagnostics';

export function logPerformanceDatapoint(
    ...[datapoint, status, errorType]: LogPerformanceDatapointParams
): void {
    if (resolveDatapointTimeGate(datapoint.getOptions() ?? {}) === undefined) {
        logToTracingPanel(datapoint, status);
    }
    enrichDatapointWithAppVisibility(datapoint);

    queueOrRun(
        'logPerformanceDatapoint',
        logPerformanceDatapointFunction,
        datapoint,
        status,
        errorType
    );
}

export function logPerformanceDatapointFunction(
    ...[datapoint, status, errorType]: LogPerformanceDatapointParams
): void {
    if (resolveDatapointTimeGate(datapoint.getOptions() ?? {}) !== undefined) {
        void logPerformanceDatapointCore(
            datapoint,
            status,
            errorType,
            undefined /* batchId */,
            () => {
                runDatapointTimeGateDiagnostics(
                    () => cacheDatapointForDiagnostics(datapoint, true, status),
                    () => logToTracingPanel(datapoint, status),
                    () => logDiagnostics(datapoint)
                );
            }
        ).catch(alertWorkerLoggingError);
        return;
    }
    if (getThreadName() === 'MAIN_THREAD') {
        getAnalyticsAddon('LogInWorkerOrMainThread')?.executeWhenReady(
            logPerformanceDatapointCore,
            'logPerformanceDatapoint',
            datapoint,
            status,
            errorType
        );
    } else {
        logPerformanceDatapointCore(datapoint, status, errorType);
    }

    logDiagnostics(datapoint);
}

function logDiagnostics(datapoint: LogPerformanceDatapointParams[0]): void {
    if (!isRunningOnWorker() && getAnalyticsFlightsAndAppSettings()?.devToolsEnabled) {
        getAnalyticsAddon('LogUnifiedTelemetryDiagnostics')?.executeWhenReady(datapoint);
    }
}
